const KEY = "invalid_token_modal_state_v1"

export function loadInvalidTokenState() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}")
  } catch {
    return {}
  }
}

export function saveInvalidTokenState(state) {
  localStorage.setItem(KEY, JSON.stringify(state))
}

export function resetInvalidTokenState() {
  localStorage.removeItem(KEY)
}
